import _ from 'lodash';
import log from 'loglevel';

import { theme } from 'Components/Theme';
import { customSpaces as baseCustomSpace } from 'Components/Theme/space';

let themeConfig = null;

function getThemeConfig() {
  if (themeConfig === null) {
    themeConfig = _.defaultsDeep({}, window.themeConfig, theme);

    if (themeConfig.breakpointsAliases) {
      const { breakpoints, breakpointsAliases } = themeConfig;
      breakpointsAliases.forEach((bpAlias, index) => {
        if (breakpoints[index]) {
          breakpoints[bpAlias] = breakpoints[index];
        }
      });
    }

    if (themeConfig.spaceAliases) {
      const { space, spaceAliases } = themeConfig;
      spaceAliases.forEach((spaceAlias, index) => {
        if (space[index]) {
          space[spaceAlias] = space[index];
        }
      });
    }

    const customSpaces = themeConfig?.customSpaces ?? baseCustomSpace;
    if (customSpaces) {
      const { space } = themeConfig;
      for (const customSpaceKey in customSpaces) {
        space[customSpaceKey] = customSpaces[customSpaceKey];

        // TODO: if you need spacesWithUnit from the theme
        // spacesWithUnit[customSpaceKey] = customSpaces[customSpaceKey] + 'px';
      }
    }

    log.debug('getThemeConfig', themeConfig);
  }
  return themeConfig;
}

export default getThemeConfig;
